// extracted by mini-css-extract-plugin
export var closeButton = "_m5-2";
export var closeButtonIcon = "_m5-3";
export var lightboxContent = "_m5-1";
export var lightboxOverlay = "_m5-0";